import React from "react";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { Clock, Webhook, Code, Zap, Wrench, Layout, Mail, MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const TRIGGER_CONFIG = {
    TIME: { Icon: Clock, key: "monitoring.trigger.time" },
    WEBHOOK: { Icon: Webhook, key: "monitoring.trigger.webhook" },
    API: { Icon: Code, key: "monitoring.trigger.api" },
    EVENT: { Icon: Zap, key: "monitoring.trigger.event" },
    TOOL: { Icon: Wrench, key: "monitoring.trigger.tool" },
    APP: { Icon: Layout, key: "monitoring.trigger.app" },
    EMAIL: { Icon: Mail, key: "monitoring.trigger.email" },
    WHATSAPP: { Icon: MessageCircle, key: "monitoring.trigger.whatsapp" },
};

function TriggerBadge({ type }) {
    const { t } = useTranslation();
    const config = TRIGGER_CONFIG[type];
    if (!config) return <Badge variant="outline" className="text-[10px] px-1 py-0">{type}</Badge>;
    const { Icon, key } = config;
    return (
        <Badge variant="outline" className="text-[10px] px-1 py-0 gap-0.5">
            <Icon className="h-2.5 w-2.5" />
            {t(key)}
        </Badge>
    );
}

export default TriggerBadge;
